<script>
  import { VueMaskDirective as mask } from 'v-mask'
  import service from '../../../../domain/comitentes/services/comitente'
  import * as Status from '../../../../domain/comitentes/helpers/PessoaStatus'
  import {fileToBase64} from '../../../_default/utils/fileToBase64'

  let _default = {
    dAlterarSenha: {
      etapa: 0,
      conta: null,
      senha: null
    },
    criarUsuario: {
      etapa: 0,
      conta: null,
      email: null,
      senha: null
    },
    removerUsuario: {
      etapa: 0,
      conta: null,
      confirmar: null
    }
  }

  export default {
    components: {},
    nome: 'comitente',
    directives: {mask},
    data () {
      return {
        data: null,
        isUploadingImage: false,
        uploadingImageStatus: {
          percent: 0
        },
        dAlterarSenha: Object.assign({}, _default.dAlterarSenha),
        criarUsuario: Object.assign({}, _default.criarUsuario),
        removerUsuario: Object.assign({}, _default.removerUsuario),
        saLogs: [],
        arquivoImagem: ''
      }
    },
    computed: {
      apiUrl () {
        return process.env.API_URL
      },
      enderecoPrincipal () {
        if (this.data.pessoa.enderecos && this.data.pessoa.enderecos.length > 0) {
          let endereco = this.data.pessoa.enderecos.slice().shift()
          return [endereco]
        }
        return null
      },
      outrosEnderecos () {
        if (this.data.pessoa.enderecos && this.data.pessoa.enderecos.length > 1) {
          let enderecos = this.data.pessoa.enderecos.slice()
          enderecos.shift()
          return enderecos
        }
        return null
      },
      getEmails () {
        if (!this.data.pessoa.emails) {
          return 'Sem e-mail'
        }
        let emails = this.data.pessoa.emails.slice().map((e) => {
          return e.email
        })
        return emails.join(', ')
      }
    },
    mounted () {
    },
    activated () {
    },
    created () {
      this.$loaderOverlay.open().message('Aguarde enquanto carregamos os dados')
      service.find(this.$route.params.id)
        .then((response) => {
          this.$loaderOverlay.hide()
          this.data = response.data
        })
        .catch((response) => {
          this.$loaderOverlay.hide()
          console.log(response)
        })
    },
    deactivated () {
      this.$destroy() // no keep-alive
    },
    watch: {},
    methods: {
      Status () {
        return Status
      },
      round: function (number, precision) {
        let factor = Math.pow(10, precision)
        let tempNumber = number * factor
        let roundedTempNumber = Math.round(tempNumber)
        return roundedTempNumber / factor
      },
      print: function () {
        window.print()
      },
      adjustFirstLetter (v) {
        return v.charAt(0).toLowerCase() + v.slice(1)
      },
      editar () {
        this.$router.push({name: 'comitente.editar', params: {id: this.data.id}})
      },
      deletar () {
        if (!window.confirm('Tem certeza que deseja remover este cadastro?')) {
          return
        }
        service.deletar(this.data.id)
          .then((response) => {
            alert('Deletado com sucesso!')
            this.$router.push({name: 'comitentes'})
          })
          .catch((error) => {
            alert('Não foi possível deletar')
            console.log(error)
          })
      },
      resetEtapas () {
        this.dAlterarSenha = Object.assign({}, _default.dAlterarSenha)
        this.criarUsuario = Object.assign({}, _default.criarUsuario)
        this.removerUsuario = Object.assign({}, _default.removerUsuario)
      },
      alterarSenhaEtapa ($e) {
        this.saLogs = []
        if ($e === 1) {
          this.resetEtapas()
        }
        if ($e === 2) {
          if (this.data.usuarios.length < this.dAlterarSenha.conta) {
            return
          }
        }
        this.dAlterarSenha.etapa = $e
        this.$nextTick(() => {
          this.$refs['senha' + $e].focus()
        })
      },
      alterarSenha () {
        this.$refs['senha' + this.dAlterarSenha.etapa].blur()
        let senha
        let user = this.data.usuarios[this.dAlterarSenha.conta - 1]
        if (this.dAlterarSenha.senha === null || this.dAlterarSenha.senha === '') {
          senha = Math.random().toString(36).slice(-8)
        } else {
          senha = this.dAlterarSenha.senha
        }
        this.saLogs.push({message: 'Alterando senha...'})
        service.alterarSenha({password: senha}, user.id)
          .then((response) => {
            this.saLogs.push({message: '<span class="text-white">Senha alterada com sucesso!</span>'})
            this.saLogs.push({message: '--------------------------------------------------------'})
            this.saLogs.push({message: 'Login: <span class="text-white">' + user.username + '</span>'})
            this.saLogs.push({message: 'Nova senha: <span class="text-white">' + senha + '</span>'})
            this.saLogs.push({message: '--------------------------------------------------------'})
            console.log(response)
          })
          .catch((error) => {
            this.saLogs.push({message: '<i class="text-danger">Não foi possível atualizar a senha</i>'})
            console.log(error)
          })
      },
      criaUsuarioEtapa ($e) {
        if ($e === 1) {
          this.resetEtapas()
        }
        this.saLogs = []
        this.criarUsuario.etapa = $e
        this.$nextTick(() => {
          this.$refs['usuario' + $e].focus()
        })
      },
      criaUsuario () {
        this.$refs['usuario' + this.criarUsuario.etapa].blur()
        let senha = this.criarUsuario.senha
        if (senha === null || senha === '') {
          senha = Math.random().toString(36).slice(-8)
        }
        this.saLogs.push({message: 'Criando conta...'})
        service.criaUsuario({
          username: this.criarUsuario.conta,
          email: this.criarUsuario.email,
          password: senha,
          pessoa: {id: this.data.pessoa.id}
        })
          .then((response) => {
            if (!Array.isArray(this.data.usuarios)) {
              this.data.usuarios = []
            }
            this.data.usuarios.push(response.data)
            this.saLogs.push({message: '<span class="text-white">Usuário criado com sucesso!</span>'})
            this.saLogs.push({message: '--------------------------------------------------------'})
            this.saLogs.push({message: 'Login: <span class="text-white">' + response.data.username + '</span>'})
            this.saLogs.push({message: 'Email: <span class="text-white">' + response.data.email + '</span>'})
            this.saLogs.push({message: 'Nova senha: <span class="text-white">' + senha + '</span>'})
            this.saLogs.push({message: '--------------------------------------------------------'})
            console.log(response)
          })
          .catch((error) => {
            this.saLogs.push({message: '<i class="text-danger">Não foi possível criar o usuário :(</i>'})
            this.saLogs.push({message: '<i class="text-danger">' + JSON.stringify(error.data) + '</i>'})
            console.log(error)
          })
      },
      removeUsuarioEtapa ($e) {
        this.saLogs = []
        if ($e === 1) {
          this.resetEtapas()
        }
        if ($e === 2) {
          let usuario = this.data.usuarios.filter(u => u.username === this.removerUsuario.conta)
          if (usuario.length === 0) {
            this.saLogs.push({message: '<i class="text-danger">Usuário não encontrado.</i>'})
            return
          }
        }
        this.removerUsuario.etapa = $e
        this.$nextTick(() => {
          this.$refs['usuarioRemove' + $e].focus()
        })
      },
      removeUsuario () {
        this.$refs['usuarioRemove' + this.removerUsuario.etapa].blur()
        if (!(this.removerUsuario.confirmar && this.removerUsuario.confirmar.toUpperCase() === 'S')) {
          this.saLogs.push({message: '<i class="text-warning">Você não confirmou para remover o usuário. Cancelando...</i>'})
          window.setTimeout(() => {
            this.saLogs = []
            this.removerUsuario.etapa = 0
            this.removerUsuario.conta = null
            this.removerUsuario.confirmar = null
          }, 3000)
          return
        }
        this.saLogs.push({message: 'Removendo conta...'})
        let id = this.data.usuarios.filter(c => c.username === this.removerUsuario.conta).map(d => d.id)
        service.removeUsuario(id)
          .then((response) => {
            this.saLogs.push({message: '<span class="text-white">Usuário removido com sucesso!</span>'})
            this.data.usuarios = this.data.usuarios.filter(c => c.username !== this.removerUsuario.conta)
            console.log(response)
          })
          .catch((error) => {
            this.saLogs.push({message: '<i class="text-danger">Não foi possível remover o usuário :(</i>'})
            this.saLogs.push({message: '<i class="text-danger">' + JSON.stringify(error.data) + '</i>'})
            console.log(error)
          })
      },
      carregarImagem: async function (e) {
        this.isUploadingImage = true
        const arquivo = e.target.files[0]
        if (e.target.value === '' || !arquivo) {
          return
        }
        try {
          this.arquivoImagem = await fileToBase64(arquivo)
          e.target.value = ''
          service.uploadFoto({data: this.arquivoImagem, filename: 'foto'}, this.data.id, (e) => {
            console.log('Upload in progress...')
            let percent = e.loaded / e.total * 100
            this.uploadingImageStatus.percent = percent
            if (percent >= 100) {
              window.setTimeout(() => {
                this.isUploadingImage = false
              }, 1000)
            }
          })
            .then((response) => {
              this.data.imagemUrl = response.data.imagemUrl
              this.data.imageInfo = response.data.imageInfo
              this.data.mostrarLogo = true
              window.setTimeout(() => {
                this.isUploadingImage = false
              }, 1000)
              console.log(response)
            })
            .catch((response) => {
              this.isUploadingImage = false
              window.alert('Não foi possível carregar a imagem, algum problema ocorreu, tente novamente.')
              console.log(response)
            })
        } catch (e) {
          this.isUploadingImage = false
          window.alert('Não foi possível carregar a imagem, algum problema ocorreu, tente novamente.')
          console.log(e)
        }
      }
    }
  }
</script>

<template>
  <transition name="slide">
    <div v-if="data !== null" class="content-transition">
      <div class="fade-in-down">
        <div class="bg-light lter b-b wrapper-md">
          <div class="row">
            <div class="col-md-4">
              <!--<h1 class="m-n font-thin h3">#{{ data.apelido }}</h1>
              <h1 class="m-n font-thin h3">{{ data.pessoa.nome }}</h1>-->
              <h1 class="m-n font-thin h3">Comitente</h1>
              <span class="label no-radius bg-dark"></span>
              <span class="label m-l-n-xxs no-radius bg-success"></span>
              <!--<span class="label m-l-n-xxs no-radius bg-white ">{{ lote.comitente.pessoa.nome }}</span>-->
            </div>
            <div class="col-md-8">
              <div class="visible-xs m-t-lg"></div>
              <u-button class="btn btn-sm btn-info pull-right pull-none-xs hidden-print" tabindex="1"
                        @click.prevent="print"><i class="fa fa-print m-r-xs"></i> Imprimir
              </u-button>
              <u-button class="btn btn-sm btn-default pull-right pull-none-xs m-r-sm hidden-print" tabindex="1"
                        @click.prevent="editar">
                <i class="fa fa-edit m-r-xs"></i> Editar
              </u-button>
              <u-button class="btn btn-sm btn-default btn-danger pull-right pull-none-xs m-r-sm hidden-print"
                        tabindex="1"
                        @click.prevent="deletar">
                <i class="fa fa-edit m-r-xs"></i> Deletar
              </u-button>
              <router-link :to="{name: 'comitentes'}"
                           class="pull-right pull-none-xs hidden-print m-t-xs m-r"
                           style="clear: left"><strong class="label no-radius bg-info">Voltar</strong>
              </router-link>
            </div>
          </div>
        </div>
        <div class="wrapper-md">


          <div class="row">
            <div class="col-xs-6">
              <div class="panel panel-default pos-rlt" style="display: inline-block">
                <div><a target="_blank" :href="data.imagemUrl"><img :src="data.imageInfo && data.imageInfo.thumb.url || data.imagemUrl" style="max-width: 300px"></a>
                </div>
                <div v-show="isUploadingImage" class="progress progress-xs bg-white-opacity m-b-none" style="margin-top: -6px; z-index: 999; position: relative">
                  <div class="progress-bar bg-info" :style="'width:' + uploadingImageStatus.percent + '%;'"></div>
                </div>
                <div class="panel-footer bg-light lter">
                  <ul class="nav nav-pills nav-sm hidden-print">
                    <li class="m-r">
                      <a href="" class="fileContainer">
                        <i class="fa fa-camera text-muted"></i>
                        <input @change="carregarImagem"
                               accept="image/*"
                               type="file"/>
                      </a>
                    </li>
                    <li><label class="i-switch bg-success m-t-xs m-r">
                      <input type="checkbox" v-model="data.mostrarLogo">
                      <i></i>
                    </label></li>
                  </ul>
                </div>
              </div>
              <div class="m-t-n m-b"><small class="font-thin m-t-n">Resolução: 200x81px</small></div>
              <h4>{{ data.pessoa.nome }}</h4>
              <p v-if="data.grupo">Grupo {{ data.grupo.nome }}</p>

              <p v-for="endereco in enderecoPrincipal">
                {{ endereco.logradouro }}{{ endereco.numero && ', ' + endereco.numero }} {{ endereco.complemento &&
                endereco.complemento}} <br>
                {{ endereco.bairro }} {{ endereco.cep ? ', ' + endereco.cep : '' }}<br>
                {{ endereco.municipio ? endereco.municipio.nome : endereco.cidadeOutros }}, {{ endereco.municipio &&
                endereco.municipio.uf ? endereco.municipio.uf.nome : endereco.ufOutros }}
              </p>
              <p class="b-t" v-for="endereco in outrosEnderecos">
                {{ endereco.logradouro }}{{ endereco.numero && ', ' + endereco.numero }} {{ endereco.complemento &&
                endereco.complemento}} <br>
                {{ endereco.bairro }}<br>
                {{ endereco.municipio ? endereco.municipio.nome : endereco.cidadeOutros }}, {{ endereco.municipio &&
                endereco.municipio.uf ? endereco.municipio.uf.nome : endereco.ufOutros }}
              </p>
              <p>
                <span v-for="telefone in data.pessoa.telefones">Telefone: {{ telefone.telefone | formataTelefone }}<i
                  v-if="telefone.celular" class="fa fa-mobile-phone m-l-xs"></i> <br></span>
              </p>
              <p v-if="data.pessoa.emails && data.pessoa.emails.length > 0">
                Email{{ data.pessoa.emails && data.pessoa.emails.length > 1 ? 's' : '' }}: <span>{{ getEmails  }}</span>
              </p>
              <p>
                IP origem cadastro: <span>{{ data.pessoa.ipCadastro  }}</span>
              </p>
              <p v-if="data.pessoa.observacao">
                Observações:<br><br>
                {{ data.pessoa.observacao }}
              </p>
            </div>
            <div class="col-xs-6 text-right text-left-print">
              <p class="h4">#{{ data.id }}</p>
              <h5>Cadastro realizado{{ data.pessoa.origem ? ' pelo ' + data.pessoa.origem.origem.toLowerCase() :
                '' }} {{ moment(data.pessoa.dataCadastro.date).format('LLLL') }}</h5>
              <div>
                {{ data.pessoa.tipo === 1 ? 'Pessoa Física' : 'Pessoa Jurídica' }}<br>
                <div v-if="data.pessoa.tipo === 1">
                  CPF: <span v-if="data.pessoa.cpf">{{ data.pessoa.cpf | formataCpf }}</span><span v-else>Sem CPF</span><br>
                  RG: {{ data.pessoa.pfRg }} {{ data.pessoa.pfRgOrgaoEmissor }} {{
                  data.pessoa.pfRgDataExpedicao }}<br>
                  Nascimento: <span v-if="data.pessoa.pfDataNascimento">{{ moment(data.pessoa.pfDataNascimento.date).format('L') }}, {{data.pessoa.pfDataNascimento.date|moment}}</span><br>
                  Estado Civil: {{ Status().EstadoCivil[data.pessoa.pfEstadoCivil] }}<br>
                  Sexo: {{ data.pessoa.pfSexo === 1 ? 'Masculino' : 'Feminino' }}<br>
                  <div v-if="data.conjugeNome">
                    Cônjuge: {{ data.conjugeNome }}<br>
                    CPF Cônjuge: <span
                    v-if="data.conjugeCpf">{{ data.conjugeCpf | formataCpf }}</span><span
                    v-else>Sem CPF</span><br>
                    RG Cônjuge: <span v-if="data.conjugeRg">{{ data.conjugeRg }}</span><span
                    v-else>Sem RG</span><br>
                  </div>
                </div>
                <div v-if="data.pessoa.tipo === 2">
                  CNPJ: <span v-if="data.pessoa.cnpj">{{ data.pessoa.cnpj | formataCnpj }}</span><span
                  v-else>Sem CNPJ</span><br>
                  Inscrição Estadual: {{ data.pessoa.pjInscricaoEstadual }}<br>
                  Nome Fantasia: {{ data.pessoa.pjNomeFantasia }}<br>
                  Razão Social: {{ data.pessoa.pjRazaoSocial }}<br>
                  Responsável: {{ data.pessoa.pjResponsavel || data.pjProprietarioNome }}<br>
                  CPF: <span
                  v-if="data.pjProprietarioCpf">{{ data.pjProprietarioCpf | formataCpf }}</span><span
                  v-else>SEM CPF DO RESPONSÁVEL</span>
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>
      <!-- LOGIN TIP -->
      <div class="wrapper">
        <div class="shell-wrap">
          <p class="shell-top-bar">Sistema de Acesso</p>
          <ul class="shell-body" style="min-height: 200px">
            <!--<li>Login status: <span class="font-bold text-white">Active</span></li>
            <li>Username: <span class="font-bold text-white">{{ data.username }}</span></li>-->
            <li class="salert">
              <table class="table-shell">
                <thead>
                <tr>
                  <th>CONTA</th>
                  <th>LOGIN</th>
                  <th>EMAIL</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(usuario, key) in data.usuarios">
                  <td>{{ key+1 }}</td>
                  <td>{{ usuario.username }}</td>
                  <td>{{ usuario.email }}</td>
                </tr>
                <tr v-if="!data.usuarios || data.usuarios.length === 0">
                  <td colspan="3">Não existe conta de acesso para este comitente</td>
                </tr>
                </tbody>
              </table>
            </li>
            <li v-show="dAlterarSenha.etapa > 0" class="m-t">
              Digite a conta que deseja efetuar a operação:
              <input ref="senha1" v-on:keyup.enter="alterarSenhaEtapa(2)" type="text" v-model="dAlterarSenha.conta"/>
            </li>
            <li v-show="dAlterarSenha.etapa > 1">
              Digite a nova senha
              <i class="text-white">(deixe em branco para gerar automaticamente)</i>:
              <input ref="senha2" v-on:keyup.enter="alterarSenha" type="password" v-model="dAlterarSenha.senha"/>
            </li>

            <li v-show="criarUsuario.etapa > 0" class="m-t">
              Digite o novo login:
              <input ref="usuario1" v-on:keyup.enter="criaUsuarioEtapa(2)" type="text" v-model="criarUsuario.conta"/>
            </li>
            <li v-show="criarUsuario.etapa > 1">
              E-mail:
              <input ref="usuario2" v-on:keyup.enter="criaUsuarioEtapa(3)" type="text" v-model="criarUsuario.email"/>
              <!--<span contenteditable="true"></span>-->
            </li>
            <li v-show="criarUsuario.etapa > 2">
              Digite a nova senha
              <i class="text-white">(deixe em branco para gerar automaticamente)</i>:
              <input ref="usuario3" v-on:keyup.enter="criaUsuario" type="password" v-model="criarUsuario.senha"/>
            </li>

            <li v-show="removerUsuario.etapa > 0" class="m-t">
              Digite o login:
              <input ref="usuarioRemove1" v-on:keyup.enter="removeUsuarioEtapa(2)" type="text"
                     v-model="removerUsuario.conta"/>
            </li>
            <li v-show="removerUsuario.etapa > 1">
              Tem certeza que deseja remover a conta <strong>{{ removerUsuario.conta }}</strong> <span
              class="text-warning">(S/N)</span>:
              <input ref="usuarioRemove2" v-on:keyup.enter="removeUsuario" size="2" maxlength="1" type="text"
                     v-model="removerUsuario.confirmar"/>
            </li>

            <li v-for="m in saLogs" v-html="m.message" class="salert"></li>
          </ul>
        </div>
        <div class="m-t">
          <a class="btn btn-default" @click="criaUsuarioEtapa(1)"><i class="fa fa-user m-r-sm"></i> Criar novo
            usuário</a>
          <a class="btn btn-default" @click="alterarSenhaEtapa(1)"><i class="fa fa-lock m-r-sm"></i> Alterar senha</a>
          <a class="btn btn-danger btn-sm" @click="removeUsuarioEtapa(1)"><i class="fa fa-remove m-r-sm"></i> Remover
            uma conta</a>
        </div>
      </div>
    </div>
  </transition>
</template>



// WEBPACK FOOTER //
// VisualizarComitente.vue?62608f3f